export default "__VITE_ASSET__ml7TZ2fp__"